import { render, staticRenderFns } from "./SettingGeocode.vue?vue&type=template&id=68ee140f&lang=html&"
import script from "./SettingGeocode.vue?vue&type=script&lang=js&"
export * from "./SettingGeocode.vue?vue&type=script&lang=js&"
import style0 from "./SettingGeocode.vue?vue&type=style&index=0&id=68ee140f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports